import * as React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Studio_primary from '../assets/images/Studio_primary.jpg';

function MainFeaturedPost(props) {
  const backgroundURL = './images/page_header_background.jpg';
  return (
    <Paper
      sx={{
        position: 'relative',
        backgroundColor: 'grey.800',
        color: '#fff',
        mb: 4,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: '100%',
        backgroundImage: `url(${backgroundURL})`,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: 'rgba(0,0,0,.3)',
        }}
      />
      <Grid
        container
        sx={{ p: { xs: 5, lg: 10 } }}
        justifyContent='center'
        alignContent='center'
      >
        <Grid
          item
          sm={7}
          justifyContent='center'
          alignContent='center'
          sx={{ pt: { lg: 2 } }}
        >
          <Box
            sx={{
              position: 'relative',
              textAlign: 'center',
            }}
          >
            <Typography
              sx={{ fontSize: { xs: 40, md: 60 } }}
              variant='primary'
              color='inherit'
              gutterBottom
            >
              Welcome to my Craft Room
            </Typography>
            <Typography
              component='p'
              variant='primary'
              color='inherit'
              gutterBottom
              sx={{ fontSize: { xs: 25, md: 35 } }}
            >
              Explore the world of arts and crafts with me. Where visions and
              ideas are crafted and painted, each with their own story. Here you
              will find one of a kind pieces and can create your own custom
              piece.
            </Typography>
            <div class='elfsight-app-ea24b06f-1fa2-4b14-8432-6e9eb9546d02'></div>
          </Box>
        </Grid>
        <Grid
          item
          sm={5}
          justifyContent='center'
          alignContent='center'
          sx={{ p: { xs: 5, lg: 5 } }}
        >
          <Box
            sx={{
              textAlign: 'center',
            }}
          >
            <img
              src={Studio_primary}
              alt={'logo'}
              width={'100%'}
              style={{
                borderRadius: 10,
                boxShadow: '5px 5px 5px 5px #ffff66',
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default MainFeaturedPost;
